<template>
  <div class="orderprocessnew-list">
    <v-card >

      <v-app-bar flat v-bind:class="classSupervision('text-xl-h5')" >
        <v-icon>mdi-basket</v-icon>

        <v-badge
            style="badge-border-radius: '50px'"
            :content="totalOrders"
            :value="totalOrders"
            inline
        >
          <v-toolbar-title class="title pl-1" v-bind:class="classSupervision('text-xl-h5')">
            <router-link class="routerLink" :to="{ name: 'OrderListNew', params: { }  }">{{$t('order.orders')}}</router-link>
          </v-toolbar-title>
        </v-badge>
        <v-spacer></v-spacer>
      </v-app-bar>
      <template>
        <v-app-bar>
         
            <v-combobox
              v-model="selectedState"
              :items="orderstateSelectItems"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('order.state')"
              item-text="name"
              item-value="@id"
              @change="filteredOrdersStatus"
            />
         <v-spacer />
          <v-switch
            :label="getSwitchLabel"
            v-model="assignedFilter"
            @change="filteredOrders"
          />


        </v-app-bar>
        
      </template>

      <v-card-text>
        <div v-if="!role" class="font-weight-bold ml-4 mb-2" v-bind:class="classSupervision('text-xl-h6')">
          {{$t('global.timeline')}}
        </div>
        <div v-else class="font-weight-bold ml-4 mb-2" v-bind:class="classSupervision('text-xl-h6')">
          {{$t('priority.priority')}}
        </div>
        <v-simple-table align-center dense class="decalage" v-if="orders">
          <tr class="home"
              v-for="order in orders"
              :key="order.id"
          >

            <td>

            <v-simple-table>
              <tr>
                <td width="10"></td>
                <td width="150">
                  <!-- imgage -->
                  <v-img
                      class="rounded-xl"
                      height="100"
                      width="100"
                      v-if="order.designFile"
                      @click="showHandler(order)"
                      @contextmenu = "showHandlerExt($event,order)"
                      lazy-src="@/assets/3dfile.png"
                      :key="componentKey"
                      :src="getImageUrlByObject(order.designFile)"
                  />
                </td>
                <td>
                  <button class="text-left" v-bind:class="classSupervision('text-xl-h6')" @click="showHandler(order)" @contextmenu = "showHandlerExt($event,order)">
                    <div>
                      <!-- Id + Ref + Quantite -->
                      <strong class="text-h6">{{ order.id }} - {{order.ref}} -- x{{order.quantity}}</strong><br/>
                      <!-- Client -->
                      {{$t('customer.customer')}} : {{ order.customer.name }}<br/>
                      <!-- Etat d'ordre + type d'ordre -->
                    <span :style="{ color:order.state.couleur  }">{{ order.state.name }}</span> - {{ order.type.name }} <br/>
                      <!-- date de livraison previsionnel en internne -->
                    {{$t('order.delivery_short_interne')}} : <span v-if="order.delivery"> {{ formatDate(order.delivery, 'long') }}</span><span v-else>{{$t('order.no_delivery')}}</span><br/>
                      <!-- date de livraison desire par le client -->
                    {{$t('order.delivery_short')}} : <span v-if="order.deliveryObjectif"> {{ formatDate(order.deliveryObjectif, 'long') }}</span><span v-else>{{$t('order.no_delivery')}}</span><br/>
                    </div>
                  </button>
                </td>
              </tr>
            </v-simple-table>
            </td>
<!--          </v-timeline-item>-->
          </tr>

        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from "@/mixins/FileMixin";

export default {
  name: 'OrderListNew',
  servicePrefix: 'Order',
  mixins: [ListMixin, FileMixin],
  props: {
    supervision: {
      type: Boolean,
      required: false,
      default: () => false
    },
    role: {
      type: Boolean, //1 for labo, 0 for comm
      required: true,
    }

  },
  components: {
  },
  data() {
    return {
      selectedState: null,
      filter: '100x100',
      userProfil: null,
      orderDatas: null,
      assignedFilter: this.operator,
      
    };
  },
  mounted() {
    this.orderstateGetSelectItems( { 'params': { 'order[name]'  : 'asc'} });
    this.userGetData({data: 'profil'});
    this.user = this.dataUser('profil');
    this.filteredOrders();
   if (this.supervision) this.pollData();
  },
  computed: {
    
    user: {
      get() { return this.userProfil },
      set(value) { this.userProfil = value; }
    },
    ...mapFields('orderstate', {
      orderstateSelectItems: 'selectItems',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    ...mapState('order', {
      updatedata: 'updatedata',
    }),
    ...mapGetters('order',{
      dataOrder: 'data',
    }),
    orders: {
        get() { return this.orderDatas },
         set(value) { this.orderDatas = value; }
      },
    ...mapFields('order', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      view: 'view'
    }),
    totalOrders() {
      if (this.orderDatas) return this.orderDatas.length;
      return 0;
    },
    ...mapGetters('designfile', {
      designfiles: 'list'
    }),
    ...mapFields('designfile', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
  getSwitchLabel() {
    const profil = this.userProfil.profilInterface?.name;
    if (profil === 'operateur') {
      return this.assignedFilter
        ? this.$t('order.assigned')
        : this.$t('order.new');
    } else {
      return this.assignedFilter
        ? this.$t('order.assigned')
        : this.$t('order.withoutOperator');
    }
  },

  },
  methods: {
    showHandlerExt(event, item) {
      let routeData = this.$router.resolve({
        name: `${this.$options.servicePrefix}Show`,
        params: { id: item['@id'] }
      });
      window.open(routeData.href, '_blank');
      event.preventDefault()
    },
    ...mapActions({
      userGetData: 'user/data'
    }),
    ...mapActions('designfile', {
      getDesignFiles: 'fetchAll'
    }),
    ...mapActions({
      orderstateGetSelectItems: 'orderstate/fetchSelectItems',
    }),
    ...mapActions({
      orderGetSelectItems: 'order/fetchAllData'
    }),
    classSupervision(classText) {
      if (this.supervision) return classText;
      return '';
    },
    colorOrderBackground() {
      return "background-color: " + this.order.state.couleur
    },
    filteredOrders() {
      const profil = this.userProfil.profilInterface?.name;

      const params = {
        'order[priority.updated]': 'desc',
        'itemsPerPage': '20',
        'exists[operator]': this.assignedFilter ? 1 : 0,
      };

      // Si aucun état sélectionné, filtrer selon profil
      if (this.selectedState === null) {
        if (profil === 'operateur') {
          params['state.labo'] = 1;
        } else {
          params['state.specialCommerciauxHome'] = 1;
        }
      } else {
        params['state'] = this.selectedState.id;
      }

      this.orderGetSelectItems({params,data: 'ordersnew',});
    },


    filteredOrdersStatus() {
      this.orders.filter(order => order.state === this.selectedState);
      return this.filteredOrders()
      
    },
    pollData () {

      // Si la page n'est pas actif, on ne recherche pas de nouvelles commandes
      if (!document.hidden) {

        this.polling = setInterval(() => {
          if (!document.hidden) {
            this.filteredOrders()
          }
        }, 100000);
      }
    },

    orderaction() {
      this.$router.push({ name: `OrderCreate` });
    },
  },
  watch: {
    updatedata: function (updatedata) {
      if (updatedata == 'ordersnew') {
        this.orders = this.dataOrder('ordersnew');
      }
    },
  }
};
</script>
<style>
tr.home {
  height: 140px;
}
.decalage {
  padding-left: 2%;
}

</style>